const global = window

inputs.alias.palette = 'color'

inputs.types.color = function (data, name, niceName, type, input, parent, inputWindow) {
    const inputColorChange = function (color) {
        if (color) {
            const currentColor = color.toLocaleString()
            input.val(currentColor)
            input.attr('value', currentColor)
            input.attr('data-value', currentColor)
            input.css('background-color', currentColor)
            input.css('border-color', currentColor)
            if (color.isDark()) {
                input
                    .css('color', '#ffffff')
                    .next()
                    .css('color', '#ffffff')
            } else {
                input
                    .css('color', '#000000')
                    .next()
                    .css('color', '#000000')
            }
        } else {
            input.val('')
            input.css('background-color', '')
            input.css('border-color', '')
            input.css('color', '').next().css('color', '')
        }
    }
    let options = {
        preferredFormat: 'hex',
        color: input.val(),
        showPalette: false,
        maxSelectionSize: 6,
        hideAfterPaletteSelect: true,
        showAlpha: (data.alpha == true),
        showButtons: false,
        showInput: false,
        allowEmpty: !data.mandatory,
        offset: function() {
            const offset = input.offset();
            const height = input.outerHeight();
            const picker = input.spectrum('container');
            const pickerHeight = picker.outerHeight();
            const viewHeight = $(window).height();
            const scroll = $(window).scrollTop();

            if (offset.top + height + pickerHeight > scroll + viewHeight && offset.top - scroll > pickerHeight) {
                return { top: offset.top - pickerHeight, left: offset.left };
            }
            return { top: offset.top + height, left: offset.left };
        },
        move(color) {
            inputColorChange(color)
        },
        change(color) {
            inputColorChange(color)
        }
    }
    if (data.options && data.options.length) {
        options.palette = data.options
        options.showPalette = true
    }
    if (data.type == 'palette') {
        options.showPaletteOnly = true;
        options.showPalette = true;
    }

    input.spectrum(options)
    input.change(function () {
        $(this).spectrum('set', $(this).val())
        inputColorChange($(this).spectrum('get'))
    })
    input.click(function () {
        $(this).spectrum('show')
    })
    input.on('dragstop.spectrum', function (e, color) {
        inputColorChange(color)
        input.trigger('change')
    })
    inputColorChange(input.spectrum('get'))
    return data
}
